export const TimesheetFormulaVI = {
  "formulaTitle": {
    "valueRequire" : "Nhập giá trị",
    "calculationRequire" : "Cách tính là trường bắt buộc!",
    "calculationToolTip" : "Công chuẩn sẽ được trừ đi số ngày nghỉ của doanh nghiệp/tổ chức trong tháng tại Cài đặt nghỉ lễ",
    "formulaValueRequire" : "Nhập công thức/giá trị",
    "keywordRequire" : "Nhập từ khóa",
    "column_cell" : "Nhập tên cột/ô",

    "changeRequire" : "Nhập thay đổi",
    "tableRequire" : "Nhập bảng",
    "timekeepingFormula" : "Công thức chấm công",
    "standardWorkday" : "Công chuẩn",
    "table" : "Bảng",
    "change" : "Thay đổi",
    "nameCell" : "Tên cột/ô",
    "keyword" : "Từ khóa",
    "formula" : "Công thức/giá trị",
    "result" : "Kết quả",
    "description" : "Mô tả",
    "calculation" :  "Cách tính",
    "value" : "Giá trị",
    "department" : "Phòng ban ",
    "jobPosition" : "Vị trí",
    "note" : "Ghi chú",
    "automaticDate" : "Tính toán lại tự động bảng công từ",
    "columnKeyword" : "Cột",
    "name" : "Tên",
    "default" : "Giá trị mặc định",
    "example" : "Ví dụ",
    "noteKeyword" : "Ghi chú"
  },
  "tabFormula": {
    "SHIFT_KEYWORD": "Cài đặt chung",
    "KEYWORD": "TK(từ khóa) bảng ca",
    "DATE_KEYWORD": "TK bảng ngày",
    "OVERTIME_KEYWORD": "TK bảng làm thêm",
    "MISSION_KEYWORD": "TK bảng bảng đơn công tác",
    "HOURLY_LEAVE_KEYWORD": "TK bảng bảng đơn vắng mặt",
    "MONTHLY_APPLICATION_KEYWORD": "TK bảng đơn tháng",
    "CHECK_IN/OUT_KEYWORD": "TK bảng chốt vân tay"
  },
  "formulaPlaceholder": {
    "formula" : "Công thức bắt đầu  bằng  dấu =",
    "table" : "Chọn bảng",
    "change" : "Chọn thay đổi",
    "cellColumn" : "Tên côt/ô",
    "keyword" : "Từ khóa",
    "valueFormula" : "Giá trị hoặc công thức",
    "result" : "Số/chữ",
    "description" : "Mô tả",
    "calculation" :  "Cách tính",
    "value" : "Giá trị là số ",
    "department" : "Phòng ban ",
    "jobPosition" : "Vị trí",
    "note" : "Bạn có thể ghi chú nội dung qui định chấm công ở đây ",
    "informationNote0" : "Hướng dẫn : ",
    "informationNote1" : "Công thức/giá trị viết hoàn toàn như excel . ",
    "informationNote2" : "Ví dụ : ",
    "informationNote3" : "IF( SO_PHUT_DI_MUON > 90,1,0) .",
    "informationNote4" : "Ngoài ra, để sử dụng các hàm thống kê có thể dùng công thức tham chiếu với các tên bảng: ",
    "informationNote5" : " bảng tổng hợp tháng và thông tin nhân sự ",
    "informationNote6" : " bảng tính toán công cho tất cả các ca làm việc ",
    "informationNote7" : " bảng tính toán công cho tất cả các ngày ",
    "informationNote8" : " bảng tính toán công cho tất cả các ca làm thêm ",
    "informationNote9" : " bảng đơn công tác ",
    "informationNote10" : " bảng đơn vắng mặt ",
    "informationNote11" : "Ví dụ: ",
    "informationNote12" : "=COUNT( CA!SO_PHUT_DI_MUON > 10 ) ",
    "informationNote13" : "trả lại số lần đi muộn lớn hơn 10 phút trong tháng",
    "informationDate0" : "Khi bạn chọn thời gian tính công từ tháng thì chỉ áp dụng tính toán lại công tự động cho thời điểm đó trở đi . ",
    "informationDate1" : "Ví dụ: Chọn từ tháng 6/2021 thì công sẽ tính tự động tính toán lại từ tháng 6 trở đi, còn khi không chọn sẽ tính tính toán 2 tháng gần nhất. (Chỉ áp dụng với bảng công chưa chốt công)"
  },
  "typeArray" : {
    "month" : "Tháng",
    "date" : "Ngày" ,
    "shift" : "Ca",
    "overtime" : "Làm thêm",
    "meeting" : "Đơn Vắng mặt ",
    "mission" : "Đơn Công tác",
    "checkin/out" : "Chốt vân tay",
    "formula" : "Công thức",
    "ColumnNew" : "Cột mới",
    "RowNew" : "Hàng mới",
    "number" : "Kiểu số",
    "text" : "Kiểu chữ",

    "other" : "Theo ngày cố định",
    "subSunday" : "Số ngày trong bảng chấm công trừ ngày CN",
    "subSaturday" : "Số ngày trong bảng chấm công trừ ngày T7",
    "subSaturdaySunday" : "Số ngày trong bảng chấm công trừ ngày T7,ngày CN",
    "subHalfSaturdayAndSunday": "Số ngày trong bảng chấm công trừ nửa ngày T7, nửa ngày CN",
    "subHalfSaturdaySunday": "Số ngày trong bảng chấm công trừ nửa ngày T7 , ngày CN",
    "subSaturdayHalfSunday": "Số ngày trong bảng chấm công trừ cả ngày T7 , nửa ngày CN",
    "subHalfNDay": "Số ngày trong bảng chấm công trừ n ngày ",
    "totalShift" : "Tổng số ca được phân trong bảng phân ca",

  },
  "actionFormula": {
    "update" : "Cập nhật",
    "cancel" : "Hủy bỏ",
    "error" : "giá trị phải lớn hơn 0 "
  }
}
